module.exports = __webpack_public_path__ + "img/53.7d72f344.jpg";